import CardIcon from 'molecules/CardIcon';
import Logo from 'atoms/Logo';
import React from 'react';
import Image from 'next/image';
import SettingsStepsSidebar from 'organisms/settings/SettingsStepsSidebar';

const SidebarWithTimeline = ({
  className = '',
  height = 'h-screen',
  width,
  showTimeLine = false,
  timeLineListData = [],
  showImage = false,
  classForLogo = 'w-[13%] h-[9%]',
  type,
}) => {
  if (showTimeLine) {
    return (
      <div
        className={`hidden relative overflow-hidden w-full md:flex flex-col border-r border-secondary-200 ${width} ${height} ${className}`}
      >
        <SettingsStepsSidebar
          timeLineListData={timeLineListData}
          showCardIcon
          className="h-full p-4 lg:p-6"
        />
      </div>
    );
  }

  return (
    <div
      className={`hidden relative overflow-hidden w-full md:flex gap-y-2 flex-col border-r border-secondary-200 justify-between p-6 ${width} ${height} ${className}`}
    >
      <Logo
        src="/images/aftoLogoBlue.svg"
        alt="Afto"
        className={classForLogo}
      />
      <CardIcon className="mx-auto" type={type} />
      {showImage && (
        <div className="absolute left-1/2 inset-y-0 w-full h-full">
          <Image
            src="/images/sidebarImage.svg"
            alt="sidebar Image"
            layout="fill"
          />
        </div>
      )}
    </div>
  );
};

export default SidebarWithTimeline;
